import { cloneDeep } from 'lodash-es'

export const getPermissions = (state) => state._inits?.user?.permissions || []
export const getMenus = (state) => state._inits?.user?.menus || {}
export const getOptions = (state) => state.options.options || {}

/**
 * Normalisasi `user.permissions` ke flat `string[]`.
 *
 * Terima dua bentuk input:
 * - tree-object lama (`{ name, child: [...] }`, `child` rekursif)
 * - flat `string[]` baru (langsung nama permission)
 *
 * Hanya field `name` yang load-bearing. `parent_id`, `is_parent`, `position`
 * diabaikan. Idempoten untuk input `string[]`. Kosong/nullish → `[]`.
 *
 * @param input {Array<string>|Array<Object>|Object|null|undefined}
 * @return {Array<string>}
 */
export const flattenPermissions = (input) => {
  if (!input) {
    return []
  }
  // Fast path: BE (Laravel enum string) kirim array `string[]` homogen. Kalau item pertama
  // string, sisanya pasti string (kalau tidak, itu bug BE). Batasi ke array supaya cabang
  // `Object.values` (shape lama keyed-object) tetap lewat normalisasi penuh.
  if (Array.isArray(input) && typeof input[0] === 'string') {
    return input
  }
  const list = Array.isArray(input) ? input : Object.values(input)
  const result = []
  list.forEach((item) => {
    if (typeof item === 'string') {
      result.push(item)
      return
    }
    if (item && typeof item === 'object') {
      if (item.name) {
        result.push(item.name)
      }
      if (item.child) {
        result.push(...flattenPermissions(item.child))
      }
    }
  })
  return result
}

/**
 * Rekonstruksi objek permission dari flat list, kompatibel dengan konsumen lama.
 *
 * @param state {Object}
 * @param name {string}
 * @return {{isCanAdd: boolean, isCanEdit: boolean, isCanDelete: boolean, isCanReconciliation: boolean}}
 */
export const getModulePermissions = (state, name) => {
  const list = getPermissions(state)
  const _actions = {
    isCanAdd: list.includes(`${name}_add`),
    isCanEdit: list.includes(`${name}_edit`),
    isCanDelete: list.includes(`${name}_delete`),
    isCanReconciliation: list.includes(`${name}_reconcile`),
  }
  // Over-populate: tiap nama permission jadi key `true`, tanpa prefix. Kebal ke
  // nama child tak konsisten (subtree `reports`).
  list.forEach((permission) => {
    _actions[permission] = true
  })
  return _actions
}
const checkPermissionMain = (permissions, name) => permissions.includes(name)
export const checkPermission = (state, name) => {
  const permissions = getPermissions(state)
  return checkPermissionMain(permissions, name)
}
export const getFirstUrl = (data, url) => {
  for (let i = 0; i < data.length; i += 1) {
    if (data[i].sub) {
      url = getFirstUrl(data[i].sub, url)
      break
    } else if (!data[i].divider && data[i].url && data[i].url !== '/') {
      url = data[i].url
      break
    }
  }
  return url
}
export const isGrantToDashboard = (state) => {
  const menus = getMenus(state)
  const dashboard = menus.dashboard || []
  const findDashboard = dashboard.find((row) => row.name === 'home')

  return !!findDashboard
}
export const getRedirectUrl = (menus) => {
  if (!menus) {
    return '/'
  }
  const _menus = cloneDeep(menus)
  const dashboard = _menus.dashboard || []
  const settings = _menus.settings
    ? _menus.settings.map((e) => {
        e.url = `/settings${e.url}`
        return e
      })
    : []
  let url = getFirstUrl(dashboard, '')
  if (url === '') {
    url = getFirstUrl(settings, '')
  }

  return url === '' ? '/' : url
}
